import { CognitoJwtVerifier } from "aws-jwt-verify";

const verifier = CognitoJwtVerifier.create({
    userPoolId: process.env.REACT_APP_USER_POOL_ID as string,
    tokenUse: "access",
    clientId: process.env.REACT_APP_USER_POOL_APP_CLIENT_ID as string,
});

const verifyAwsToken = async (token: string | null) => {
    try {
        if (!token) return ({ status: false, payload: null })
        const payload = await verifier.verify(token);
        return {
            status: true,
            payload: payload
        }
    } catch {
        return {
            status: false,
            payload: null
        }
    }
}

export default verifyAwsToken